module.exports = __webpack_public_path__ + "img/23.e67c3d08.jpg";